/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Alert, Cell, Grid, Heading, Modal, ModalBody, Text } from 'bold-ui'
import { PageLoading } from 'components/loading'
import { useAlergiasModalQuery } from 'graphql/hooks.generated'
import React from 'react'
import { useHistory, useRouteMatch } from 'react-router'
import formatAlergias from 'view/atendimentos/detail/soap/aside/alergias/formatAlergias'
import { AlergiaReacaoModel } from 'view/atendimentos/detail/soap/avaliacao/components/alergias-reacoes/model'

import { AccordionAlergiasModal } from './AccordionAlergiasModal'

interface ListaAlergiasModalProps {
  prontuarioId: ID
  alergiasAvaliadas: AlergiaReacaoModel[]
}

export function ListaAlergiasModal(props: ListaAlergiasModalProps) {
  const { prontuarioId, alergiasAvaliadas } = props
  const history = useHistory()
  const match = useRouteMatch()

  const { data, loading } = useAlergiasModalQuery({
    variables: { filtro: { prontuarioId: prontuarioId } },
  })

  const todasAlergias = formatAlergias(data?.alergias?.content ?? [], alergiasAvaliadas, true).getAlergias()

  const onClose = () => history.push(match.url.replace('/lista-alergias', ''))

  return (
    <Modal open={true} onClose={onClose}>
      <ModalBody>
        <Grid>
          <Cell size={12}>
            <Heading
              level={1}
              style={css`
                margin-bottom: 1rem;
              `}
            >
              Alergias/Reações adversas
            </Heading>
            <Alert inline type='info'>
              A evolução de alergias do cidadão pode ser registrada na Avaliação, em Alergias/Reações adversas.
            </Alert>
          </Cell>
          {loading && <PageLoading message='Carregando dados' />}
          {!loading && (
            <React.Fragment>
              <Cell size={12}>
                {todasAlergias.length === 0 ? (
                  <Text component='p'>Nenhuma alergia ou reação adversa registrada.</Text>
                ) : (
                  <AccordionAlergiasModal alergias={todasAlergias} />
                )}
              </Cell>
            </React.Fragment>
          )}
        </Grid>
      </ModalBody>
    </Modal>
  )
}
